module.exports = "/packs/as_img05-fd1ff68f0b8d9538d061190f58cc845f.png";